<div class="vq-dialog" role="dialog" aria-labelledby="avqd-title">
  <div class="vqd-head">
    <div class="t">
      <h2 id="avqd-title">{{ data.currentQuote ? 'Change Vendor Quote' : 'Add Vendor Quote' }}</h2>
      <p>For <b>{{ data.materialName }}</b>. Use a quote you already have, or upload the vendor's new one.</p>
    </div>
    <button type="button" class="vqd-x" (click)="cancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <div class="vqd-body">
    <!-- The line as it stands, so both choices can be judged against it -->
    <div class="now">
      <span class="k">Now on this PO</span>
      <b class="num">{{ data.qty }} {{ data.unit }}</b>
      <span>× <b class="num">{{ data.unitCost | currency }}</b></span>
      <span>from <b>{{ data.vendorName || 'No vendor' }}</b></span>
      @if (data.currentQuote) {
        <span class="cq"><mat-icon>request_quote</mat-icon>{{ data.currentQuote }}</span>
      }
    </div>

    <div class="pick">
      <button type="button" class="card" [class.dis]="!data.quoteCount" [disabled]="!data.quoteCount"
        (click)="choose('select')">
        <span class="ic"><mat-icon>fact_check</mat-icon></span>
        <span class="tt">Select an existing quote</span>
        <span class="ds">Pick from the vendor quotes that already list this material.</span>
        <span class="ft">
          @if (data.quoteCount) {
            <span class="fact"><b>{{ data.quoteCount }}</b> quote{{ data.quoteCount === 1 ? '' : 's' }} available</span>
            @if (data.lowestPrice != null) {
              <span class="fact">from <b class="num">{{ data.lowestPrice | currency }}</b></span>
            }
            @if (lowestSaves > 0) {
              <span class="vqd-tag low">Save {{ lowestSaves | currency }}/{{ data.unit }}</span>
            }
          } @else {
            <span class="fact">No quote lists this material yet</span>
          }
        </span>
        <span class="go"><mat-icon>arrow_forward</mat-icon></span>
      </button>

      <button type="button" class="card" (click)="choose('upload')">
        <span class="ic up"><mat-icon>upload_file</mat-icon></span>
        <span class="tt">Upload a vendor quote</span>
        <span class="ds">Upload the vendor's PDF or photo. We read the vendor, materials and prices for you.</span>
        <span class="ft">
          <span class="fact">You check it before it's used</span>
        </span>
        <span class="go"><mat-icon>arrow_forward</mat-icon></span>
      </button>
    </div>
  </div>

  <div class="vqd-foot">
    <span class="note">The quote's vendor and price go on this PO line.</span>
    <button type="button" class="vqd-btn" (click)="cancel()">Cancel</button>
  </div>
</div>
